import { classes } from "lib/actions/util";

export default function GroupedMenuItems(
  p: React.PropsWithChildren<{ className?: string }>,
) {
  return (
    <div
      className={classes(
        "divide-y rounded-lg bg-white px-3 shadow-1",
        p.className,
      )}
    >
      {p.children}
    </div>
  );
}
